import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import './App.scss';
import AboutPage from './pages/about/aboutPage';
import ContactPage from './pages/contactPage';
import FaqPage from './pages/faq/faqPage';
import Home from './pages/home/home';
import IOSInvitation from './pages/iOSInvitation/iOSInvitation';
import Layout from './pages/layout';
import LegalPage from './pages/legal/legalPage';
import BridgePage from './pages/other/bridgePage';
import { LanguageProvider } from './services/LanguageContext'; // Import LanguageProvider

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          {/* Redirect root to default language */}
          <Route path="/" element={<Navigate replace to="/de" />} />

          {/* Define a route that uses the Layout */}
          <Route path="/:lang" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="legal/:pageType" element={<LegalPage />} />
            <Route path="iOSInvitation" element={<IOSInvitation />} />
            <Route path="Anmeldung" element={<BridgePage />} />
          </Route>
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
